<div class="row">
  <div class="col-md-6">
    <div class="card card-body">
      @if(newOrganisation){
        <form class="form-horizontal"
          #organisationForm="ngForm">
          <div class="form-group row">
            <app-material-pg-input
                label="شناسه"
                type="text"
                id="name"
                name="name"
                [required]="true"
                [disabled]="edit"
                [(ngModel)]="internalName">
            </app-material-pg-input>
          </div>
          <div class="form-group row">
            <app-material-pg-input
                label="مجموعه"
                type="text"
                id="parentOrganisation"
                name="parentOrganisation"
                [disabled]="true"
                [(ngModel)]="newOrganisation.parentOrganisation"
                [required]="true">
            </app-material-pg-input>
          </div>
          <div class="form-group row">
            <app-material-pg-input
                label="نام فارسی "
                id="farsiName"
                name="farsiName"
                [required]="true"
                [(ngModel)]="newOrganisation.nameTranslations['fa']">
            </app-material-pg-input>
          </div>
          <div class="form-group row">
            <app-material-pg-input
                label="نام انگلیسی"
                type="text"
                id="englishName"
                name="englishName"
                [required]="true"
                [(ngModel)]="newOrganisation.nameTranslations['en']">
            </app-material-pg-input>
          </div>
          <div class="form-group row">
            <app-material-pg-input
                label="مدیر"
                type="text"
                id="manager"
                name="manager"
                [(ngModel)]="newOrganisation.manager">
            </app-material-pg-input>
          </div>
          <div class="form-group row">
            <app-material-pg-input
                label="آدرس"
                type="text"
                id="address"
                name="address"
                [(ngModel)]="newOrganisation.address">
            </app-material-pg-input>
          </div>
          <div class="form-group row">
            <app-material-pg-input
                class="col-md-6"
                label="latitude"
                type="number"
                id="latitude"
                name="latitude"
                [(ngModel)]="newOrganisation.location!.latitude">
            </app-material-pg-input>
            <app-material-pg-input
                class="col-md-6"
                label="longitude"
                type="number"
                id="longitude"
                name="longitude"
                [(ngModel)]="newOrganisation.location!.longitude ">
            </app-material-pg-input>
          </div>
          <div class="form-group row">
            <app-material-auto-complete
              [formatter]="formatter"
              [(ngModel)]="newOrganisation.timezone"
              [items]="availableTimeZones"
              name="timezone"
              [placeholder]="'Timezone '"
              id="timezone"
              [required]="true">
            </app-material-auto-complete>
          </div>
            @if (showAdditionalData) {
              <div class="form-group row">
                <app-material-auto-complete
                  [(ngModel)]="addData"
                  name="addData"
                  (ngModelChange)="addExtendedProp($event)"
                  [items]="objectKeys(additionalProp)"
                  [formatter]="formatter"
                  [placeholder]="'New Extended item'"
                  id="addData"
                  [required]="true">
                </app-material-auto-complete>
              </div>
            }
            @if (showAvailableProp) {
              <div class="form-group row">
                <app-material-auto-complete
                  [(ngModel)]="addProp"
                  name="addProp"
                  (ngModelChange)="addAvailableProp($event)"
                  [items]="objectKeys(availableProperties)"
                  [formatter]="availablePropFormatter"
                  [placeholder]="'New Property item'"
                  id="addProp"
                  [required]="true">
                </app-material-auto-complete>
              </div>
            }

          @for(f of objectKeys(additionalPropDic); track $index){
            <div class="form-group row">
              <app-material-pg-input
                  class="col-md-10"
                  label="{{$any (additionalProp)[f]}}"
                  type="text"
                  id="{{f}}"
                  name="{{f}}"
                  [(ngModel)]="additionalPropDic[f]"
                  [required]="true">
              </app-material-pg-input>
              <div class="col-md-2  ">
                <app-material-pg-icon-button
                  icon="delete_outline"
                  iconClass="fs-4 me-3 text-primary"
                  class="ms-auto"
                  (clicked)="removeAdditionalProp(f)">
                </app-material-pg-icon-button>
              </div>
            </div>
          }
          @for(f of objectKeys(propertyDic); track $index ){
          <div class="form-group row">
            <div class="col-md-4">
              <mat-checkbox
                id="f"
                name="f"
                [(ngModel)]="propertyDic[f]">
                {{ availableProperties[f] }}
              </mat-checkbox>
            </div>
          </div>
          }
          <div class="form-group row">
          <div>
            <app-material-pg-button
                (clicked)="showAdditionalProp()"
                name="Additional Data"
                label="AdditionalProp">
            </app-material-pg-button>
            <app-material-pg-button
                (clicked)="showAvailables()"
                name="New Flag"
                class="pull-right me-2"
                label="New Flag">
            </app-material-pg-button>
            <app-material-pg-button
                (clicked)="add()"
                [disabled]="!organisationForm.form.valid"
                class="pull-right me-2"
                label="Save">
            </app-material-pg-button>
          </div>
          </div>
        </form>
      }
    </div>
  </div>
</div>
